import { request, combineUrl, localConfig } from '~/common';

const flightRequest = ({ trans, ...params }, callback, action) => {
    return request(combineUrl(localConfig.obtApiUrl, `Flights/V1/json/${action}`), params, callback, { trans });
}

export function searchFlightCalendar(params, callback) {
    return flightRequest(params, callback, 'SearchFlightCalendar');
}

export function searchFlightCalendarDetail(params = { CalendarId: '', ProfileToken: '' }, callback) {
    return flightRequest(params, callback, 'SearchFlightCalendarDetail');
}